import { useEffect, useState } from "react";
//#region src/icons/support/use-is-2x-resolution.ts
const HAS_WINDOW = typeof window !== "undefined";
/** Allows use of this utility in SSR (will simply return `false`) */
const SSR_MEDIA_QUERY_LIST = {
	matches: false,
	addEventListener: () => {},
	removeEventListener: () => {}
};
function matchMediaOrSsr(query) {
	return HAS_WINDOW ? window.matchMedia(query) : SSR_MEDIA_QUERY_LIST;
}
const IS_2X_RESOLUTION = matchMediaOrSsr("screen and (min-resolution: 2dppx)");
function useMediaQuery(query) {
	const [matches, setMatches] = useState(query.matches);
	useEffect(() => {
		function onChange(e) {
			setMatches(e.matches);
		}
		query.addEventListener("change", onChange);
		return () => query.removeEventListener("change", onChange);
	}, [query]);
	return matches;
}
function useIs2xResolution() {
	return useMediaQuery(IS_2X_RESOLUTION);
}
//#endregion
export { useIs2xResolution };

//# sourceMappingURL=use-is-2x-resolution.js.map